import { uploadPhotoToAWS } from "@notemeal/shared/ui/Image/uploadUtils";
import axios from "axios";
import { useState } from "react";
import { useSnackbar } from "../../Snackbar/SnackbarContext";

interface useUploadPhotoProps {
  onComplete: (imageUrl: string) => any | Promise<any>;
}

export const useUploadPhoto = ({ onComplete }: useUploadPhotoProps): [(url: string) => {}, boolean] => {
  const { setMessage } = useSnackbar();
  const [imageUploading, setImageUploading] = useState(false);
  const uploadPhoto = async (imageUrl: string) => {
    setImageUploading(true);
    try {
      const res = await axios.get(process.env.REACT_APP_IMAGE_UPLOAD_URL, {
        withCredentials: true,
      });
      const toUpload = await uploadPhotoToAWS({ resData: res.data, imageUrl });

      await onComplete(toUpload);
    } catch (e) {
      console.error(e);
      if (e instanceof Error) {
        setMessage("error", e.message);
      } else {
        setMessage("error", "Something went wrong!");
      }
    }
    setImageUploading(false);
  };

  return [uploadPhoto, imageUploading];
};
